import { NgModule } from '@angular/core';
import { NgxEleuiLibComponent } from './ngx-eleui-lib.component';

@NgModule({
  imports: [
  ],
  declarations: [NgxEleuiLibComponent],
  exports: [NgxEleuiLibComponent]
})
export class NgxEleuiLibModule { }
